export const CHANGE_PANEL_TYPE     = 'CHANGE_PANEL_TYPE';
export const TOGGLE_DETAILS_PANEL  = 'TOGGLE_DETAILS_PANEL';
export const DISPLAY_DETAILS_PANEL = 'DISPLAY_DETAILS_PANEL';
export const NEW_PANEL_DATA        = 'NEW_PANEL_DATA';
export const CHANGE_BORDER_RADIUS  = 'CHANGE_BORDER_RADIUS';
export const TOGGLE_BOX_SHADOW     = 'TOGGLE_BOX_SHADOW';
export const TOGGLE_TOP_NAVIGATION = 'TOGGLE_TOP_NAVIGATION';
export const FROM_FIELD            = 'FROM_FIELD';
export const SUBMIT_LOADING        = 'SUBMIT_LOADING';
export const TOGGLE_MENU_ACTIONS   = 'TOGGLE_MENU_ACTIONS';

export function changeType(string) {
  return dispatch => Promise.resolve(dispatch({
    type: CHANGE_PANEL_TYPE,
    payload: { type: string, isLoading: true }

  }));

} // END changeType

export function newData(data = {}) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_PANEL_DATA,
    payload: { data: data, isLoading: false }

  }));

} // END newData

export function toggleDetailsPanel() {
  return dispatch => Promise.resolve(dispatch({
    type: TOGGLE_DETAILS_PANEL

  }));

} // END toggleDetailsPanel

export function openDetailsPanel(conf) {
  const options = { open: true };
  if (conf) {
    if (typeof conf !== "object" && !Array.isArray(conf)) conf = {};
    const { onSave, onClose, onError } = conf.hooks;
    Object.assign(options, { hooks: { onSave, onClose, onError } } );

  } // END if

  return dispatch => Promise.resolve(dispatch({
    type: DISPLAY_DETAILS_PANEL,
    payload: options

  })); // END return

} // END openDetailsPanel

export function closeDetailsPanel() {
  return dispatch => Promise.resolve(dispatch({
    type: DISPLAY_DETAILS_PANEL,
    payload: { open: false, field:null }

  }));

} // END closeDetailsPanel

export function changeBorderRadius() {
  return {
    type: CHANGE_BORDER_RADIUS

  };

} // END changeBorderRadius

export function toggleBoxShadow() {
  return {
    type: TOGGLE_BOX_SHADOW

  };

} // END toggleBoxShadow

export function toggleTopNavigation() {
  return {
    type: TOGGLE_TOP_NAVIGATION

  };

} // END toggleTopNavigation

export function toggleMenuActions(show) {
  return {
    type: TOGGLE_MENU_ACTIONS,
    payload: { show: show }

  };

} // END toggleTopNavigation

export function fromField(field) {
  return dispatch => Promise.resolve(dispatch({
    type: FROM_FIELD,
    payload: { field: field, isLoading: false}

  }));

} // fromField

export function onChangeIsLoadingButton(value) {
  return dispatch => Promise.resolve(dispatch({
    type: SUBMIT_LOADING,
    payload: { isLoadingButton: value }

  }));

} // onChangeIsLoadingButton



// WEBPACK FOOTER //
// ./src/redux/actions/detailsPanelActions.js